module.exports = __webpack_public_path__ + "img/ic24Pname.a41365c0.svg";